import { useEffect, useState } from "react";
import { listPending, onQueueChange } from "../offline/queue";
import { useConnectionStatus } from "../realtime/realtime";
import { relativeTime } from "../format";

const labels = { online: "verbunden", connecting: "verbinde …", reconnecting: "verbinde neu …", offline: "offline" } as const;

/** Sichtbarer Verbindungs- und Synchronisationsstatus inkl. noch nicht übertragener Aktionen. */
export function ConnectionBadge() {
  const status = useConnectionStatus();
  const [pending, setPending] = useState(0);
  const [browserOnline, setBrowserOnline] = useState(navigator.onLine);

  useEffect(() => {
    const refresh = () => void listPending().then((p) => setPending(p.length));
    refresh();
    const off = onQueueChange(refresh);
    const on = () => setBrowserOnline(navigator.onLine);
    window.addEventListener("online", on);
    window.addEventListener("offline", on);
    return () => {
      off();
      window.removeEventListener("online", on);
      window.removeEventListener("offline", on);
    };
  }, []);

  const state = browserOnline ? status.state : "offline";
  return (
    <span className={`badge conn-${state}`} title={status.lastSync ? `Stand: ${relativeTime(status.lastSync)}` : undefined} role="status">
      <span className="dot" aria-hidden="true" />
      {labels[state]}
      {pending > 0 && <strong className="pending"> · {pending} nicht synchronisiert</strong>}
    </span>
  );
}
